module.exports = __webpack_public_path__ + "img/bespoke_cubeAir53.c22fdae7.png";